import { ContractsLocalStorageRepo } from './ContractsLocalStorageRepo';
import { AuthLocalStorageRepo } from './AuthLocalStorageRepo';

export class LocalStorageRepo {
  static contracts = new ContractsLocalStorageRepo();
  static auth = new AuthLocalStorageRepo();
}
